import { buildStore } from '@redux-eggs/core';
import { configureStore, combineReducers, compose } from '@reduxjs/toolkit';

/**
 *  port of https://github.com/fostyfost/redux-eggs/blob/31fc5c42a60867b98d6e4a4a6d9465d432f95a20/packages/redux-toolkit/src/index.ts
 *  in order to evade outdated @reduxjs/toolkit dependencies and update code to latest configureStore syntax
 *  NOTE: we are not using the `main` branch as v3 is not @redux-eggs is not released
 * */

const createStore = ({
  combiner = combineReducers,
  defaultMiddlewareOptions,
  devTools,
  extensions
} = {}) => buildStore((reducer, middlewareEnhancer, enhancersFromExtensions, middlewaresFromExtensions) => configureStore({
  reducer,
  devTools,
  enhancers(getDefaultEnhancers) {
    return getDefaultEnhancers().concat(...enhancersFromExtensions);
  },
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware(defaultMiddlewareOptions).prepend(middlewaresFromExtensions).concat(middlewareEnhancer);
  }
}), combiner, compose, extensions);

export { createStore };
